import paths from '@app/src/wf-constants/paths'
import { LocalLibrary, LocalLibraryOutlined } from '@mui/icons-material'
import React from 'react'
import { useIntl } from 'react-intl'
import NavigationMenuItem from '../VerticalMenu/NavigationItems/NavigationMenuItem'

const YourDataMenuItem: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <NavigationMenuItem
      path={paths.yourData}
      title={formatMessage({ id: 'navbar.yourData' })}
      icon={LocalLibraryOutlined}
      iconSelected={LocalLibrary}
    />
  )
}

export default YourDataMenuItem
